import type { TooltipContentMessageFlags } from './types.tsx';

type GetTooltipContentMessageFlags = (
	params: TooltipContentMessageFlags,
) => TooltipContentMessageFlags | null;

export const getMessageFlags: GetTooltipContentMessageFlags = ({
	uneditable,
	unrequirable,
	unsortable,
	unremovable,
}) => {
	const hasContent = [uneditable, unrequirable, unsortable, unremovable].some(Boolean);

	if (!hasContent) {
		return null;
	}

	return {
		uneditable,
		unrequirable,
		unsortable,
		unremovable,
	};
};
